import { useMutation, useQueryClient } from '@tanstack/react-query'

import { prayApi } from '../../pray/api/prayApi'
import { PRAY_OBJECT_TYPE } from '../../pray/models/prayObjectType'
import { getCommentsOptions } from './useCommentsQuery'

export const usePrayCommentPublicationMutation = (publicationId: number) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (id: number) => prayApi.createPrayer({ objectId: id, objectType: PRAY_OBJECT_TYPE.COMMENT }),
    onSuccess(_, id) {
      queryClient.setQueryData(
        getCommentsOptions(publicationId).queryKey,
        (data) =>
          data && {
            ...data,
            pages: data.pages.map((comments) =>
              comments.map((comment) =>
                comment.id === id ? { ...comment, hasPrayed: true, prayersCount: comment.prayersCount + 1 } : comment,
              ),
            ),
          },
      )
    },
  })
}
